import { Pipe, PipeTransform } from '@angular/core';
import { buildTreatmentsSelectPanelList } from './treatments-select-panel.util';

/**
 * Panel list for treatment multiselect: all selected (form order) + unselected
 * (name-filtered when search is set). Keeps mat-options for every selected id.
 */
@Pipe({ name: 'treatmentsSelectPanel', pure: true })
export class TreatmentsSelectPanelPipe implements PipeTransform {
  transform(
    catalog: any[] | null | undefined,
    searchTerm: string | null | undefined,
    selectedIds: any[] | null | undefined
  ): any[] {
    return buildTreatmentsSelectPanelList(catalog, searchTerm, selectedIds);
  }
}
